const QuestionnaireType = {
  PreQualifying: 1,
  Form: 2,
  FormGroup: 3,
};

export default QuestionnaireType;
